export interface TimezoneModel {
  id: string;
  displayName: string;
}

export interface SystemConfigModel {
  name: string;
  hostUrl: string;
  timeZone: string;
  ianaTimeZone: string;
  notificationEmails: string[];
  separateProductEachBranch: boolean;
  loginType: string;
}
export const LoginTypeConst = {
  LoginPhone: "LoginPhone",
  LoginEmail: "LoginEmail"
}
export const LoginTypeTextList = [LoginTypeConst.LoginEmail,LoginTypeConst.LoginPhone];
